import type { SeverityLabel, SeverityThresholds } from "./types";

export const DEFAULT_SEVERITY_THRESHOLDS: SeverityThresholds = {
  high: 0.7,
  med: 0.4,
};

export function normalizeThresholds(value: unknown): SeverityThresholds {
  if (
    typeof value === "object" &&
    value !== null &&
    "high" in value &&
    "med" in value
  ) {
    const high = Number((value as SeverityThresholds).high);
    const med = Number((value as SeverityThresholds).med);
    if (Number.isFinite(high) && Number.isFinite(med) && high > med && high <= 1 && med >= 0) {
      return { high, med };
    }
  }
  return DEFAULT_SEVERITY_THRESHOLDS;
}

export function severityForScore(
  score: number | null | undefined,
  thresholds: SeverityThresholds = DEFAULT_SEVERITY_THRESHOLDS,
): SeverityLabel {
  const safeScore = Number.isFinite(score) ? Number(score) : 0;
  if (safeScore >= thresholds.high) return "HIGH";
  if (safeScore >= thresholds.med) return "MED";
  return "LOW";
}
